// extracted by mini-css-extract-plugin
module.exports = {"container":"overflowPopover_container__1ufBB","overlayTop":"overflowPopover_overlayTop__notAm","overlayRight":"overflowPopover_overlayRight__25OPz"};